export interface WarpWeftPlan {
  column: number;
  row: number;
  number: number;
  extra: string;
}
